(ns dashboard.views.inference-job.detail.events
  (:require [re-frame.core :as rf]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]))

(def -view-id :route.view/inference-job-detail)

(rf/reg-event-fx
  ::fetch-job-details
  (fn [{:keys [db]} [_ questionnaire job-name]]
    {:db (assoc-in db [-view-id :fetching-details?] true)
     :http-xhrio {:method :get
                  :uri "/api/inference-job/details"
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :params {:questionnaire questionnaire
                           :job-name job-name}
                  :on-success [::set-job-details]
                  :on-failure [::ui/set-error "Could not get inference job details"]}}))

(rf/reg-event-db
 ::set-job-details
 (fn [db [_ job]]
   (update-in db [-view-id]
              merge
              {:fetching-details? false
               :details job})))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;
;; Fetch policy file list
;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-fx
  ::fetch-policy-file-list
  (fn [{db :db} _]
    {:db       (assoc-in db [-view-id :fetching-policy-files?] true)
     :http-xhrio {:method :get
                  :uri "/api/policies"
                  :response-format http-config/transit-response-format
                  :on-success [::set-policy-files]
                  :on-failure [::ui/set-error "Could not get policy files"]}}))

(rf/reg-event-db
  ::set-policy-files
  (fn [db [_ policy-files]]
    (assoc-in db
              [-view-id :policy-files]
              policy-files)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;
;; Fetch questionnaire file details
;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-fx
  ::fetch-questionnaire-file-details
  (fn [{db :db} [_ {:keys [q-uuid]}]]
    {:db       (assoc-in db [-view-id :fetching-questionnaire?] true)
     :http-xhrio {:method :get
                  :uri (str "/api/questionnaires/" q-uuid)
                  :response-format http-config/transit-response-format
                  :on-success [::set-questionnaire-file]
                  :on-failure [::ui/set-error "Could not get questionnaire file details"]}}))

(rf/reg-event-db
  ::set-questionnaire-file
  (fn [db [_ file]]
    (assoc-in db
              [-view-id :questionnaire-details]
              file)))
